// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3759f988","239":"59e90d7b","453":"0e804146","455":"bfa440fd"}[chunkId] + ".chunk.js";
};